var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox" }, [
    _c(
      "div",
      { staticClass: "v-height-flag" },
      [
        _c(
          "el-card",
          {
            class: _vm.tabCur == 0 ? "employees-card-bottom" : "employees-card",
          },
          [
            _c(
              "div",
              { staticClass: "form-wrapper" },
              [
                _vm.tabCur == 0 ? _c("plan") : _vm._e(),
                _vm._v(" "),
                _vm.tabCur == 1 ? _c("explain") : _vm._e(),
                _vm._v(" "),
                _vm.tabCur == 2 ? _c("process") : _vm._e(),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }